import { render, staticRenderFns } from "./yb.vue?vue&type=template&id=3a64dc83&scoped=true&"
import script from "./yb.vue?vue&type=script&lang=js&"
export * from "./yb.vue?vue&type=script&lang=js&"
import style0 from "./yb.vue?vue&type=style&index=0&lang=less&"
import style1 from "./yb.vue?vue&type=style&index=1&id=3a64dc83&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a64dc83",
  null
  
)

export default component.exports